module.exports = __webpack_public_path__ + "static/fig-03-8e464d911ed2ebf3f5de4c94cb7d3e58.png";